import { ObjectField, Test, TestType } from '../../parser/models/all.js';
import { isOnlyExpressionSupported, isOnlyField } from "../../parser/utils/testOnlyUtils.js";
import { PreProcessContext } from '../models/preProcessContext.js';

/**
 * Processor for identifying literal 'only' fields (e.g., `export const only = true`).
 * These fields signal that subsequent tests in the same group should be filtered.
 * 
 * @param field - The object field to check.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as an 'only' literal.
 */
export function processOnlyField(field: ObjectField, index: number, context: PreProcessContext): boolean {
  let { name, value } = field;

  const options = context.options;
  const isOnly = isOnlyField(name, options) && isOnlyExpressionSupported(value);
  if (isOnly) {
    context.tests.push(
      new Test(
        field.groupName,
        name,
        value,
        new TestType(TestType.OBJECT_WITH_ONLY),
        // test cases
        [],
        // only expression
        value
      )
    );

    return true;
  }

  return false;
}
